export const shippingPreferences = [
  { label: "Fastest", value: "fastest" },
  { label: "Cheapest", value: "cheapest" },
];
